module.exports = __webpack_public_path__ + "static/media/lbx.0dea0f97.png";